// Most marketplace visitors arrive from a shared listing link and do not have
// OpenBitFun installed yet. Keep the official download page in one place so every
// browse surface funnels to the same URL.
export const OPENBITFUN_HOME_URL = 'https://openbitfun.com/';
export const OPENBITFUN_DOWNLOAD_URL = 'https://openbitfun.com/download';
